import { getApi, patchApi } from 'utils/Api';
import FetchUserDataSchema, { FetchUserDataSchemaContract } from '../schemas/FetchUserDataSchema';
import SuccessResponseSchema, {
  SuccessResponseSchemaContract,
} from 'schemas/SuccessResponseSchema';
import {
  PeopleSearchRequest,
  PeopleSearchSuccessResponseSchemaContract,
  PeopleSearchSuccessResponseSchema,
  SaveUserUiPreferenceRequestData,
} from './types/peopleTypes';

const people = {
  search: (requestData: PeopleSearchRequest) => {
    const queryParams = new URLSearchParams();

    requestData.search && queryParams.append('search', requestData.search);
    requestData.onlyActive && queryParams.append('onlyActive', requestData.onlyActive.toString());
    requestData.type && queryParams.append('type', requestData.type);

    if (!requestData.useRoleBasedSearch) {
      requestData.userRoleBlacklist &&
        requestData.userRoleBlacklist.forEach((param: number) => {
          queryParams.append('userRoleBlacklist[]', param.toString());
        });
    }

    const endpoint = requestData.useRoleBasedSearch
      ? 'getAutocompleteListByRole'
      : 'getAutocompleteList';

    return getApi<PeopleSearchSuccessResponseSchemaContract>({
      url: `/${requestData.orgId}/${endpoint}?${queryParams.toString()}`,
      responseSchema: PeopleSearchSuccessResponseSchema,
    });
  },

  fetchUserData: (peopleId: number) => {
    return getApi<FetchUserDataSchemaContract>({
      url: `/user/${peopleId}`,
      responseSchema: FetchUserDataSchema,
    });
  },
  saveUserUiPreference: (requestData: SaveUserUiPreferenceRequestData) =>
    patchApi<SuccessResponseSchemaContract, any>({
      url: 'ui-user-preferences',
      responseSchema: SuccessResponseSchema,
      requestData,
    }),
};

export default people;
